import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: 'AIzaSyBWfFwRx00i14nLE1GvWQj-ViWqacAGoqU',
  authDomain: 'vnd-namjestaj.firebaseapp.com',
  databaseURL: 'https://vnd-namjestaj.firebaseio.com',
  projectId: 'vnd-namjestaj',
  storageBucket: 'vnd-namjestaj.appspot.com',
  messagingSenderId: '121485932328',
  appId: '1:121485932328:web:f9bb64bb4b145a0464421d',
  measurementId: 'G-L3BNWBQ46D'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()
export const auth = firebase.auth()
